import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { AllowedOsUpdatesEffects } from './allowed-os-updates.effects';
import { allowedOsUpdateFeatureKey, AllowedOsUpdatesReducer } from './allowed-os-updates.reducer';

export const provideAllowedOsUpdatesStore = () => [
  provideState(allowedOsUpdateFeatureKey, AllowedOsUpdatesReducer),
  provideEffects([AllowedOsUpdatesEffects]),
];
